import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CreateIcon from '@mui/icons-material/Create';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { duplicateNotification as duplicateNotificationAPI } from '../../../../utils/ServicesAPIUtils';
import DuplicatePopupModel from '../../../../shared/duplicate-popup/Duplicate-Popup';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  NOTIFICATIONS_TYPE,
  NOTIFICATION_CREATE,
  NOTIFICATION_EDIT,
  NOTIFICATION_FILTER,
  NOTIFICATION_VIEW,
  RECIPIENT,
  STATUS,
} from '../../../../constants/NotificationsConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_NOTIFICATIONS,
} from '../../../../constants/RoleConsts';
import ActivationPopupModel from '../../../../shared/activation-popup/Activation-Popup';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import WarningPopup from '../../../../shared/warning-popup/Warning-Popup';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  deactivateNotification,
  deleteNotification,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../utils/ServicesAPIUtils';
import {
  campainNotificatons,
  fetchAllNotifications,
  setNotificationCampaign,
} from '../../../services/servicesSlice';
import './NotificationList.scss';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  danger,
  generateConfirmationMessage,
  success,
  PARTIAL_CHECKBOX_GREEN,
  selectedCheckList,
  ResetFilterList,
} from '../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const NotificationList = (props) => {
  const [filterDataList, setFilterDataList] = useState(NOTIFICATION_FILTER);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [loading, setLoading] = useState(true);
  const [notificationList, setNotificationList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const allNotificationsOriginal = useSelector(campainNotificatons);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    activate: false,
    warning: false,
    anchorEl: null,
    offer: {},
    modalType: '',
    type: '',
    duplicateStatus: false,
  });
  const wrapperRef = useRef(null);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const isFilterApplied = useRef(false);
  const prevHotelIdRef = useRef(hotelId);

  const onOpenDrawer = (event, type) => {
    if (selectedNotificationsLength) {
      setNotificationList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.group);
    handleClose();
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      activate: false,
      warning: false,
      anchorEl: null,
      Offer: null,
      modalType: '',
      type: '',
      duplicateStatus: false,
    });
  };

  const onClickDuplicate = (event) => {
    event.stopPropagation();
    setSelectedValue((prev) => ({
      ...prev,
      anchorEl: null,
      duplicateStatus: true,
      title: 'Are you sure you want to Duplicate',
      description: 'Please provide a name to be assigned for the duplicated notification.',
    }));
  };
  const duplicateNotificationItem = async (event, name) => {
    event?.stopPropagation?.();
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      await duplicateNotificationAPI(selectedValue.id, hotelId, selectedLang, name);
      dispatch(fetchAllNotifications(hotelId));
      notificationManager('success', 'Notification duplicated successfully');
    } catch (e) {
      notificationManager(
        'danger',
        e?.graphQLErrors ? e.graphQLErrors[0]?.message : 'Failed to duplicate Notification',
      );
    } finally {
      dispatch(stepDownLoaderCount());
      handleClose();
    }
  };

  useEffect(() => {
    const withCheck = allNotificationsOriginal?.map((info) => {
      const isChecked = selectedCheckList(notificationList, info.id);
      return {
        ...info,
        isChecked,
      };
    });
    setNotificationList(withCheck);
    setFilteredBaseList(withCheck);
    setLoading(false);
    setSearchText('');
    resetFilterDataList();
  }, [allNotificationsOriginal]);

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(notificationList, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) => {
      return item.title.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setNotificationList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedNotificationsLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setNotificationList(ResetFilterList);
    }
  };

  useEffect(() => {
    updateSelectedModule(notificationList, setActionMenuList, setIsAllSelected);
  }, [notificationList]);

  const resetFilterDataList = () => {
    NOTIFICATION_FILTER[1].subMenu = NOTIFICATIONS_TYPE;
    NOTIFICATION_FILTER[2].subMenu = STATUS;
    NOTIFICATION_FILTER[3].subMenu = RECIPIENT;
    setFilterDataList(NOTIFICATION_FILTER);
  };

  useEffect(() => {
    resetFilterDataList();
  }, []);

  useEffect(() => {
    if (loading || notificationList?.length === 0) return;
    const totalItems = notificationList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [notificationList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const [dragEnabled, setDragEnabled] = useState(true);

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      setFilteredBaseList(allNotificationsOriginal);
      setNotificationList(allNotificationsOriginal);
      resetFilterDataList();
      isFilterApplied.current = false;
    } else {
      isFilterApplied.current = true;
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredRecords = allNotificationsOriginal.filter((notification) => {
        const doesFilterSatisfy = filterIdWithFields.map((filter) =>
          filter.id.includes(notification[filter.field]),
        );
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setNotificationList(filteredRecords);
    }
  };

  const onViewDetails = (category, e, isClassDisabled) => {
    if (isClassDisabled) return onViewToggle(NOTIFICATION_VIEW, true, category);
    if (e?.target?.tagName === 'TD') {
      onViewToggle(NOTIFICATION_VIEW, true, category);
    }
  };

  const onViewDetailsIcon = (e) => {
    if (
      e.target.className ===
      'MuiButtonBase-root MuiListItem-root MuiMenuItem-root pe-4 MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button'
    ) {
      onViewToggle(NOTIFICATION_VIEW, true, selectedValue.group);
    }
  };

  const handleCellMenuClick = (event, item) => {
    if (selectedNotificationsLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: item.id,
        name: item.title,
        title: '',
        description: '',
        status: false,
        activate: false,
        warning: false,
        isActive: item.isActive,
        anchorEl: event.currentTarget,
        group: item,
      });
    }
  };

  const handleDeletePopupOpen = () => {
    let currVal = { ...selectedValue };
    handleClose();
    if (currVal?.group?.status === 'Live' || currVal?.group?.status === 'Scheduled') {
      currVal.warning = true;
      currVal['title'] = currVal.group.title;
      currVal[
        'description'
      ] = `This Notification is currently ${selectedValue?.group?.status} and thus cannot be deleted. In order to delete this Notification, deactivate this Notification and try again.`;
      setSelectedValue(currVal);
    } else {
      currVal['title'] = 'Are you sure you want to delete';
      currVal['description'] = 'This action cannot be reversed.';
      currVal.status = true;
      currVal.anchorEl = null;
      setSelectedValue(currVal);
    }
  };

  const handleDeactivatePopupOpen = () => {
    setSelectedValue({
      ...selectedValue,
      name: `${selectedValue.name}?`,
      title: `Are you sure you want to deactivate `,
      description: 'You can reschedule it in Notification Edit page to activate this Notification.',
      status: true,
      anchorEl: null,
      activate: true,
    });
  };

  const handleActivatePopupOpen = () => {
    setSelectedValue({
      ...selectedValue,
      name: `${selectedValue.name}?`,
      title: `Are you sure you want to activate `,
      description:
        'You can reschedule it in Notification Edit page to deactivate this Notification',
      status: true,
      anchorEl: null,
      activate: true,
    });
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      ...selectedValue,
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      activate: false,
      anchorEl: null,
    });
  };

  const deleteNotifications = async () => {
    handleClose();
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      await deleteNotification(selectedValue.id, hotelId, selectedLang);
      dispatch(fetchAllNotifications(hotelId));
      notificationManager(success, 'Notification deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Notification',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const listOfNotificationIds = notificationList
    ?.filter((info) => info?.isChecked)
    ?.map((info) => info?.id);

  const deleteMultipleNotifications = async () => {
    handleClose();
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'CAMPAIGN_OFFER';
      await deleteSelectedItems(
        listOfNotificationIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllNotifications(hotelId));
      notificationManager(success, 'Notifications deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Notification',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  //Both active and deactivate statuses are handled by this function
  const handleActiveDeactivate = async () => {
    handleClose();
    resetFilterDataList();
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const state = !selectedValue?.isActive;
      await deactivateNotification(selectedValue.id, hotelId, selectedLang, state);
      dispatch(fetchAllNotifications(hotelId));
      notificationManager(
        success,
        `Notification
       ${selectedValue?.group?.status === 'Inactive' ? 'Activated' : 'Deactivated'} successfully`,
      );
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Notification was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Notification',
    listOfNotificationIds?.length,
    isActive,
  );

  //Both active and deactivate multi statuses are handled by this function
  const handleMultipleStatusChange = async (status) => {
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'CAMPAIGN_OFFER';
      await updateSelectedItemsStatus(
        listOfNotificationIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllNotifications(hotelId));
      notificationManager(success, onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        danger,
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Notification was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setNotificationList(ResetFilterList);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);
  const dragDisabled = !dragEnabled || notificationList?.length <= 1;

  // Function to handle checkbox change
  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionName = '';
    let actionList = [];
    let index = notificationList?.findIndex((info) => info.id === id);
    if (!notificationList[index]?.isChecked) {
      notificationList[index] = { ...notificationList[index], isChecked: true };
    } else {
      notificationList[index].isChecked = !notificationList[index]?.isChecked;
    }
    setNotificationList([...notificationList]);

    actionList = notificationList
      ?.filter((notification) => notification?.isChecked)
      .map((status) => status?.status);

    actionList?.forEach((action) => {
      if (['Scheduled', 'Live'].includes(action)) {
        actionName = 'Deactivate';
      } else if (['Inactive'].includes(action)) {
        actionName = 'Activate';
      }
      if (!actionListName.includes(actionName) && actionName !== '') {
        actionListName.push(actionName);
      }
    });

    const checkedItems = notificationList?.filter((notification) => notification?.isChecked);

    if (checkedItems?.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isAllSelected = notificationList?.every((info) => info?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedNotificationList = [];
    let actionListName = [];
    let actionName = '';
    const CheckedValue = event?.target?.checked;

    setIsAllSelected(CheckedValue);
    selectedNotificationList = notificationList?.map((info) => {
      return {
        ...info,
        isChecked: CheckedValue,
      };
    });
    selectedNotificationList?.forEach((action) => {
      if (['Scheduled', 'Live'].includes(action?.status)) {
        actionName = 'Deactivate';
      } else if (['Inactive'].includes(action?.status)) {
        actionName = 'Activate';
      }
      if (!actionListName.includes(actionName) && actionName !== '') {
        actionListName.push(actionName);
      }
    });
    setNotificationList([...selectedNotificationList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedNotificationList?.some((info) => info?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const handleAction = (actionName) => {
    let selectedValue = notificationList?.filter((notification) => notification?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const selectedNotificationsLength = notificationList?.filter((info) => info?.isChecked).length;

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setNotificationList(
      allNotificationsOriginal.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const formatRoomNumbers = (rooms) => {
    if (!rooms || rooms?.length === 0 || rooms?.every((room) => room === '')) {
      return '---';
    }

    if (rooms?.length === 1) {
      return rooms[0];
    } else {
      return `${rooms[0]}, +${rooms?.length - 1}`;
    }
  };

  return (
    <div>
      {selectedValue.id && selectedValue.status && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteNotifications}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {selectedValue?.duplicateStatus === true && selectedValue?.id && (
        <DuplicatePopupModel
          duplicatePopUp={selectedValue}
          onDuplicate={duplicateNotificationItem}
          onDuplicateCancel={handleClose}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedNotificationsLength} ${
            selectedNotificationsLength > 1 ? 'notifications' : 'notification'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleNotifications();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedNotificationsLength}  ${
            selectedNotificationsLength > 1 ? 'notifications' : 'notification'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}

      {selectedValue.id && selectedValue.status && selectedValue.activate && (
        <ActivationPopupModel
          activationPopUp={selectedValue}
          cancelButtonName='No'
          okButtonName='Yes'
          onOkClick={() => handleActiveDeactivate()}
          onActivationPopupActionCancel={handleClose}
        />
      )}
      {selectedValue.id && selectedValue.warning && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}
      <div className='mt-4 mb-4 group-list-container'>
        <SearchBar
          type={NOTIFICATION_CREATE}
          buttonName='Add Notifications'
          setSearchText={handleSearchText}
          onOpenDrawer={onOpenDrawer}
          filterList={filterDataList}
          setFilterDataList={setFilterDataList}
          filteredRecoard={filteredRecords}
          displayAddOrEdit={
            permissions[RBAC_TYPE_NOTIFICATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
              ? 'show'
              : 'hide'
          }
          visible={visible}
          setVisible={setVisible}
          popUp={popUp}
          setPopUp={setPopUp}
          placeHolder={notificationList}
          setPlaceHolder={setNotificationList}
          globalPlaceHolder={allNotificationsOriginal}
          setGlobalPlaceHolder={setNotificationCampaign}
          dispatch={dispatch}
          mappingApi={createDataSortMapping}
          displayText='Notifications'
          module='CAMPAIGN_OFFER'
          searchText={searchText}
          setSearch={setSearchText}
          actionMenuItems={actionMenuList ?? []}
          handleAction={handleAction ?? false}
          setDrag={setDragEnabled}
        />
        <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
          {loading ? (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          ) : (
            notificationList && (
              <TableContainer>
                <Table className='list-table' aria-label='simple table'>
                  <TableHead>
                    <TableRow className='border-white pointer'>
                      <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                        <BulkActionCheckBox
                          onChange={handleSelectAll}
                          checked={isAllSelected || false}
                          selectedLength={selectedNotificationsLength}
                          totalLength={allNotificationsOriginal?.length}
                          inputProps={{
                            'aria-label': 'select all Notifications',
                          }}
                          className={PARTIAL_CHECKBOX_GREEN}
                        />
                      </TableCell>
                      <TableCell className='w-30'>Name</TableCell>
                      <TableCell className='w-20'>Rooms</TableCell>
                      <TableCell className='w-10'>Type</TableCell>
                      <TableCell className='w-15'>Recipient</TableCell>
                      <TableCell className='w-5' align='center'>
                        Status
                      </TableCell>
                      <TableCell align='right'></TableCell>
                    </TableRow>
                  </TableHead>
                  <DragDropContext
                    onDragEnd={(event) =>
                      handleOnDragEnd(
                        event,
                        setVisible,
                        notificationList,
                        setNotificationList,
                        false,
                        page,
                        rowsPerPage,
                      )
                    }
                    isDropDisabled={dragDisabled}
                  >
                    <Droppable droppableId='campaign' isDropDisabled={dragDisabled}>
                      {(provided) => (
                        <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                          {(rowsPerPage > 0
                            ? notificationList.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage,
                              )
                            : notificationList
                          ).map((item, i) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={i}
                              isDragDisabled={!!dragDisabled}
                            >
                              {(provided) => (
                                <TableRow
                                  key={i}
                                  className='border-white pointer'
                                  onClick={(e) => {
                                    onViewDetails(item, e);
                                  }}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <TableCell className='w-12'>
                                    {!dragDisabled && (
                                      <span style={{ marginRight: 3 }}>
                                        <DragIndicator className='res-menu-accordion-drag' />
                                      </span>
                                    )}
                                    <Checkbox
                                      onChange={(event) => handleCheckboxChange(item?.id)}
                                      checked={item?.isChecked || false}
                                      inputProps={{
                                        'aria-label': `select notification ${item?.id}`,
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell className='w-30'>{item?.title}</TableCell>
                                  <TableCell className='w-20'>
                                    {formatRoomNumbers(item?.residentRoom)}
                                  </TableCell>
                                  <TableCell
                                    className='w-10'
                                    onClick={(e) => onViewDetails(item, e, true)}
                                  >
                                    {item.type}
                                  </TableCell>
                                  <TableCell className='w-15'>{item?.recipient}</TableCell>
                                  <TableCell
                                    className='w-5'
                                    onClick={(e) => onViewDetails(item, e, true)}
                                  >
                                    <div className='d-flex align-content-center'>
                                      <div
                                        className={
                                          item.statusClass +
                                          ' pill d-flex justify-content-center align-items-center w-35 py-2 px-0'
                                        }
                                      >
                                        <span>{item.status ?? 'NA'}</span>
                                      </div>
                                    </div>
                                  </TableCell>
                                  <TableCell align='right'>
                                    {permissions[RBAC_TYPE_NOTIFICATIONS] ===
                                      RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                      <Button
                                        aria-controls='simple-menu'
                                        aria-haspopup='true'
                                        onClick={(e) => {
                                          handleCellMenuClick(e, item);
                                        }}
                                        className='showpopupInner'
                                      >
                                        <MoreHoriz className='showpopupInner' />
                                      </Button>
                                    )}
                                    <Menu
                                      id={i}
                                      anchorEl={selectedValue?.anchorEl}
                                      disableRestoreFocus
                                      MenuListProps={{ autoFocusItem: false }}
                                      keepMounted
                                      open={
                                        Boolean(selectedValue.anchorEl) &&
                                        selectedValue.id === item.id
                                      }
                                      onClose={handleClose}
                                      className='shadow'
                                    >
                                      {item.status !== 'Completed' &&
                                        (selectedValue?.group?.isActive ? (
                                          <MenuItem
                                            className='pe-4'
                                            onClick={() => {
                                              handleDeactivatePopupOpen();
                                            }}
                                          >
                                            <RemoveCircleIcon className='me-2 action-menu-icon' />
                                            Deactivate
                                          </MenuItem>
                                        ) : (
                                          <MenuItem
                                            className='pe-4'
                                            onClick={() => handleActivatePopupOpen()}
                                          >
                                            <AddCircle className='me-2 action-menu-icon' />
                                            Activate
                                          </MenuItem>
                                        ))}

                                      <MenuItem
                                        className='pe-4'
                                        onClick={(e) => {
                                          onOpenDrawer(e, NOTIFICATION_EDIT);
                                        }}
                                      >
                                        <CreateIcon className='me-2 action-menu-icon' />
                                        Edit
                                      </MenuItem>
                                      <MenuItem
                                        className='pe-4'
                                        onClick={(e) => {
                                          onViewDetailsIcon(e);
                                        }}
                                      >
                                        <RemoveRedEyeIcon className='me-2 action-menu-icon' />
                                        View
                                      </MenuItem>
                                      <MenuItem
                                        className='pe-4'
                                        onClick={(e) => onClickDuplicate(e)}
                                      >
                                        <ContentCopyIcon className='me-2 action-menu-icon' />
                                        Duplicate
                                      </MenuItem>
                                      <MenuItem
                                        className='pe-4'
                                        onClick={(e) => {
                                          handleDeletePopupOpen();
                                        }}
                                      >
                                        <DeleteForeverIcon className='me-2 action-menu-icon' />
                                        Delete
                                      </MenuItem>
                                    </Menu>
                                  </TableCell>
                                </TableRow>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </TableBody>
                      )}
                    </Droppable>
                  </DragDropContext>
                  <TableFooter>
                    <TableRow className='paginator'>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        count={notificationList.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { 'aria-label': 'rows per page' },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            )
          )}
          {showBulkSearchAlert && (
            <MultipleSelectionAlert
              isOpen={showBulkSearchAlert}
              onClose={handleBulkSearchAlertClose}
              message="If you perform a search after making selections, the items you've selected will be lost."
            />
          )}
          {showBulkKebabSelectionAlert && (
            <MultipleSelectionAlert
              isOpen={showBulkKebabSelectionAlert}
              onClose={() => setShowBulkKebabSelectionAlert(false)}
              message='Please select one item from the list that you want to edit.'
              centerButtonName='OK'
            />
          )}
          {showBulkFilterAlert && (
            <MultipleSelectionAlert
              isOpen={showBulkFilterAlert}
              onClose={() => setShowBulkFilterAlert(false)}
              message="If you perform a filter after making selections, the items you've selected will be lost."
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationList;
